import { AxiosError, AxiosResponse } from 'axios';

import { IMutationProps, MutateType, useMutation } from '@pricemoov-oss/moon';

import { AuthData } from './useLogin';

export interface UseRefreshLoginVariables {
    token: string;
}

export type UseRefreshLoginResponse = AxiosResponse<AuthData>;

function useRefreshLogin(
    mutationProps?: IMutationProps<UseRefreshLoginVariables, UseRefreshLoginResponse>
) {
    return useMutation<
        // Params of the rest query
        UseRefreshLoginVariables,
        // The raw data retrieved from the backend
        UseRefreshLoginResponse,
        AxiosError
    >({
        source: 'rest',
        type: MutateType.Post,
        endPoint: '/login/refresh/',
        ...mutationProps,
    });
}

export default useRefreshLogin;
